import { NeqTableComponent } from './neq-table.component';
import { ViewChild, Directive } from '@angular/core';
import { NeqTableRequest } from './neq-table-request.model';
import { NeqAbstractViewComponent } from '../validation/abstract-view.component';
import { SortOrderUtil } from '@sharedcommon/util/sort-order.util';
import { SharedSortOrder } from '@sharedcommon/model/shared-sort-order.model';


@Directive()
export abstract class NeqHasTableComponent<T> extends NeqAbstractViewComponent {

    @ViewChild(NeqTableComponent) table: NeqTableComponent<T>;

    refreshFilters() {
      if (this.table) {
        this.table.fireRefresh();
      }
    }

    onSort() {
    }

    protected getSort(request: NeqTableRequest, fieldMapping?: Map<string, string[]>): SharedSortOrder[] {
        return SortOrderUtil.returnSortDtoFromTableRequest(request, fieldMapping);
    }

}
